import {
  ImageHomeLandingPageThumbnail,
  ImageHubThumbnailTemplate03,
  ImageSalesLandingPageThumbnail,
} from '@/assets/images';
import { HubTemplateEnum } from '@/graphql/types';
import { Box, Card, CardActionArea, CardHeader, CardMedia } from '@mui/material';
import { useEditHubStore } from '../editHubStore';

export const getHubTemplateEnumText = (key: HubTemplateEnum | string | null | undefined) => {
  switch (key) {
    case HubTemplateEnum.HomeLandingPage:
      return {
        type: HubTemplateEnum.HomeLandingPage,
        title: 'Integrated Hub',
        description: 'A hub that is integrated within the home landing page. This will never open in a new tab.',
        image: ImageHomeLandingPageThumbnail,
      };
    case HubTemplateEnum.SalesLandingPage:
      return {
        type: HubTemplateEnum.SalesLandingPage,
        title: 'Standalone Hub',
        description: 'A hub that is standalone and performs like a micro-site.',
        image: ImageSalesLandingPageThumbnail,
      };
    case HubTemplateEnum.HubTemplate_03:
      return {
        type: HubTemplateEnum.HubTemplate_03,
        title: 'Panels Hub',
        description: 'A hub that is split into two halfs. Bigger panels for more content.',
        image: ImageHubThumbnailTemplate03,
      };
    default:
      return {
        type: null,
        title: 'Unknown',
        description: 'Unknown template.',
        image: 'https://via.placeholder.com/345x140',
      };
  }
};

const DefaultSelectTemplate = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1,
        flexWrap: 'wrap',
        justifyContent: 'center',
        p: 2,
      }}
    >
      {Object.keys(HubTemplateEnum).map((key, idx) => {
        const details = getHubTemplateEnumText(HubTemplateEnum[key as keyof typeof HubTemplateEnum]);
        return (
          <Card
            key={key}
            sx={{ maxWidth: 345 }}
            onClick={() => {
              useEditHubStore.setState({ template: HubTemplateEnum[key as keyof typeof HubTemplateEnum] });
            }}
          >
            <CardActionArea>
              <CardMedia
                component="img"
                height="140"
                image={details.image}
                alt={details.title}
                sx={{
                  objectFit: 'contain',
                }}
              />
              <CardHeader title={details.title} subheader={details.description} />
            </CardActionArea>
          </Card>
        );
      })}
    </Box>
  );
};

export default DefaultSelectTemplate;
